var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCompanySwitch)?_c('b-dropdown',{staticClass:"companyswitch",attrs:{"text":_vm.currentCompany.name,"variant":"link","right":""}},_vm._l((_vm.companies),function(company){return _c('b-dropdown-item',{key:company.id,on:{"click":function($event){return _vm.swithcCompany(company)}}},[_vm._v(" "+_vm._s(company.name)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }